module.exports = __webpack_public_path__ + "612e025632f6353eea9cbb1b4b8a7a7d.svg";